export const globalSettingsIssuesCustomFieldsEditRoute = {
	name: 'global-settings-issues-custom-fields-edit',
	path: '/secure/admin/EditCustomField(\\w*)!default.jspa',
};
